import React, { useState } from 'react';
import { useParams } from "react-router-dom";
import DashboardLayout from './layout/dashboardLayout';
import LoadingOverlay from '../components/loading/loading';
import EventPage from './Events/EventPage';

const EventUpdatePage = (props) => {
    const { id } = useParams();
    const [loading] = useState(false);
    return (
        <DashboardLayout>
            {loading && <LoadingOverlay />}
            <EventPage event_id={id} />
        </DashboardLayout>
    )
};
export default EventUpdatePage;